<template>
  <div :data-component-name="$options.name" class="h-100">
    <div class="w-100 h-100 div_general">
      <b-row
        class="w-100 h-100 d-flex position-relative offre_special_container hauteurImageMobile"
      >
        <b-col cols="8" class="h-25 mt-2">
          <div v-if="content.petiteNote" class="boite_petite_note">
            <span class="petite_note graphik_bold" v-html="content.petiteNote"> </span>
          </div>
        </b-col>
        <b-col
          class="d-flex flex-column align-items-center align-items-md-start py-1 py-md-0 py-sm-0 justify-content-center position-static col-12 col-md-4 barreDessousMobile mobile_text_center"
          :style="styleObject"
        >
          <span
            v-if="content.idJeu != null"
            :class="['progressif ' + content.tailleProgressif + ' ' + content.idJeu]"
          ></span>
          <div>
            <div
              v-if="content.surTitre"
              class="offre_surtitre graphik_bold"
              v-html="content.surTitre"
            ></div>
            <h3
              v-if="content.titre"
              class="titre graphik_bold pt-0 pb-1"
              v-html="content.titre"
            ></h3>
          </div>
          <div
            v-if="content.sousTitre"
            class="sousTitre pb-3 pt-0 mt-1"
            v-html="content.sousTitre"
          ></div>

          <button
            v-if="content.texteBouton"
            class="btn graphik_bold mb-0 mt-1"
            :style="[
              { 'background-color': content.colorBtn },
              { 'border-color': content.borderColor },
            ]"
          >
            {{ content.texteBouton }}
          </button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MediaImageOffreSpecial',
  props: { content: { type: Object, required: true } },
  data() {
    return {};
  },
  computed: {
    classObject() {
      return {
        rounded: this.content.coinArrondi,
      };
    },
    imageName() {
      // TODO: M5
      // if (
      //   jel_getFichierSrc(this.content.imageFond) &&
      //   jel_getFichierSrc(this.content.imageFond).length > 0
      // ) {
      //   return jel_getFichierSrc(this.content.imageFond).substring(
      //     parseInt(jel_getFichierSrc(this.content.imageFond).lastIndexOf('/') + 1),
      //     jel_getFichierSrc(this.content.imageFond).lastIndexOf('.')
      //   );
      // }
      // if (this.content.image && this.content.image.length > 0) {
      //   return this.content.image.substring(
      //     parseInt(this.content.image.lastIndexOf('/') + 1),
      //     this.content.image.lastIndexOf('.')
      //   );
      // }
      return '';
    },
    styleObject() {
      let textColor = 'black';
      let textMobColor = 'black';
      let backgroundColor = 'transparent';
      let backgroundMobColor = '#efefef';

      if (
        (this.$mq == 'sm' || this.$mq == 'xs') &&
        this.content.fondCouleur?.field === 'couleurEdit'
      ) {
        return {
          'background-color': this.content.fondCouleur.secBgThemeColor,
          color: textColor,
        };
      }

      if (this.content.couleurTitre) {
        textColor = this.content.couleurTitre;
      }
      if (this.content.mobCouleurTitre) {
        textMobColor = this.content.mobCouleurTitre;
      }
      if (this.content.couleurFondTitre) {
        backgroundColor = this.content.couleurFondTitre;
      }
      if (this.content.mobCouleurFondTitre) {
        backgroundMobColor = this.content.mobCouleurFondTitre;
      }

      if (this.$mq == 'sm') {
        return {
          'background-color': backgroundMobColor,
          color: textMobColor,
        };
      }

      return {
        'background-color': backgroundColor,
        color: textColor,
      };
    },
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.row {
  background-position: center;
  background-repeat: no-repeat;
  margin: 0px !important;
}
.row.bgcover {
  background-size: cover;
}
.container-fluid {
  padding: 0;
}
.div_general {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.main-bingo {
  div > * {
    line-height: 1em;
  }
  .boite_petite_note {
    background-color: rgba(0, 0, 0, 0.65);
    width: fit-content;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3%;
    padding: 1.5% 3%;
    color: white;

    @include ms-respond(font-size, 0);
  }

  .titre {
    @include ms-respond(font-size, 4);
    margin: 0;
    line-height: 1;

    @include media-breakpoint-down(sm) {
      font-size: 18px;
      padding-top: 0.75rem;
    }
  }

  .btn {
    margin-bottom: 12%;
    text-transform: uppercase;
    color: black;
    @include ms-respond(font-size, -1);
    border-radius: 4rem;

    @include media-breakpoint-down(sm) {
      padding: 1rem 2.5rem;
      border-radius: 20px;
    }
  }

  .offre_surtitre {
    @include ms-respond(font-size, 0);
  }

  .sousTitre {
    @include ms-respond(font-size, 0);
    margin: 0;
    margin-top: 2%;

    @include media-breakpoint-down(sm) {
      font-size: 12px;
      margin-top: 0.75rem;
      margin-bottom: 0.75rem;
    }
  }

  .hauteurImageMobile {
    height: 70%;
    @include media-breakpoint-down(sm) {
      height: 65%;
    }
  }

  @include media-breakpoint-down(sm) {
    .offre_surtitre {
      font-size: 12px;
    }

    .barreDessousMobile {
      height: 50%;
      background-color: #efefef; //couleur background par defaut
    }

    .offre_special_container {
      align-content: space-between;
      align-items: center;
    }

    .mobile_text_center {
      text-align: center;
    }
  }
}
</style>
